export default __webpack_public_path__ + "../staticImages/mstile-150x150.png";